import * as React from 'react';
import { IDialogProps } from './IDialog';
import './Dialog.scss';
import SimpleDialog from '@mui/material/Dialog';
import { Button, DialogTitle, DialogActions, DialogContent } from '@mui/material';

const Dialog = (props: IDialogProps) => {
    return (
        <SimpleDialog className={'all-purpose-dialog ' + props.className} open={props.open} scroll="paper">
            <DialogTitle sx={{ m: 0, p: 2 }} className="d-flex dialog-headbar">
                <div className="dialog-title">{props.title}</div>
            </DialogTitle>
            <DialogContent sx={{ m: 0, p: 2 }} className="dialog-content">
                {props.children}
            </DialogContent>
            {props.actions && props.actions.length > 0 ? (
                <DialogActions className="dialog-actions" sx={{ m: 0, p: 2 }}>
                    {props.actions.map((action, index) => {
                        return (
                            <Button key={index} endIcon={action.endIcon} startIcon={action.startIcon} onClick={action.callback} color={action.color} disabled={action.disabled} variant="contained">
                                {action.text}
                            </Button>
                        );
                    })}
                </DialogActions>
            ) : !props.hideCloseButton ? (
                <DialogActions className="dialog-actions" sx={{ m: 0, p: 2 }}>
                    <Button variant="contained" color="primary" onClick={props.onClose}>
                        Ok
                    </Button>
                </DialogActions>
            ) : (
                <> </>
            )}
        </SimpleDialog>
    );
};

export default Dialog;
